export const API = {
	basePath: process.env.REACT_APP_TAGGIS_API_URL,
	frontendAppPath: process.env.REACT_APP_TAGGIS_FRONTEND_APP_URL,
};

export const LANDING_EMAIL = process.env.REACT_APP_TAGGIS_EMAIL;

export const FIELD_NAME_MAP = {
	email: 'emailLabel',
	first_name: 'firstNameLabel',
	last_name: 'lastNameLabel',
	'organisation_attributes.org_name': 'organizationLabel',
	password: 'passwordLabel',
	password_repeat: 'confirmPasswordLabel',
};

// TODO: add later TAGGIS QR here
export const TAGGIS_ELEARNING_ROUTES = {
	faq: '/taggis-elearning/faq',
	news: '/taggis-elearning/news',
	pricing: '/taggis-elearning/pricing',
	root: '/taggis-elearning',
	samples: '/taggis-elearning/samples',
};

export const TAGGIS_QR_ROUTES = {
	privacy: '/taggis-qr/privacy-qr',
	root: '/taggis-qr',
};

export const REGEX = {
	name: '^\\S.*',
	orgName: '^\\S.*',
	password: '^(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\\s).{6,73}$',
};

export const SW = {
	updateEvent: 'swupdate',
};



// WEBPACK FOOTER //
// ./src/constants/index.js